import { Action } from '@components/icons'
import WYSIWYG from '@components/ui/WYSIWYG'
import Link from 'next/link'
import { useState } from 'react'

interface Props {
  slice: any
}
const ArticleColourUsed = ({ slice }: Props) => {
  const { primary } = slice
  const { items } = slice
  const mainText = primary?.mainText
  const coloursUsedTitle = primary?.coloursUsedTitle
  const linkTitle = primary?.linkTitle
  const link = primary?.link
  const [isHover, setIsHover] = useState(false)
  const [hoveredIndex, setHoveredIndex] = useState(-1)
  const handleHover = (index: number) => {
    setIsHover(true)
    setHoveredIndex(index)
  }
  const handleLeave = () => {
    setHoveredIndex(-1)
    setIsHover(false)
  }
  return <>
    <div className="wrapper grid grid-cols-4 gap-6 bg-ui-light-grey pb-16 lg:grid-cols-12 lg:gap-8 lg:pb-20">
      {mainText && (
        <div className="mainText col-span-4 w-full text-brand-dark-grey lg:col-span-6">
          <WYSIWYG content={mainText} />
        </div>
      )}
      <div className="col-span-4 flex w-full flex-col gap-4 lg:col-span-5 lg:col-start-8 lg:gap-8 ">
        {coloursUsedTitle && (
          <div className="body-1-bold text-brand-dark-grey">
            {coloursUsedTitle}
          </div>
        )}
        {items && (
          <div>
            {items.map((item: any, index: number) => {
              const colour = item?.colour
              const colourProductHandle = item?.colourProductHandle
              const colourName = item?.colourName
              const whiteTextColour = item?.colourNameTextColour! == 'White'

              return (
                <Link
                  key={index}
                  href={`/product/${colourProductHandle}`}
                  passHref
                  legacyBehavior>
                  <div
                    style={{ background: `${colour}` }}
                    className="flex h-[96px] w-full cursor-pointer items-center justify-between px-6 py-[34px]"
                    onMouseOver={() => handleHover(index)!}
                    onMouseLeave={() => handleLeave()}
                  >
                    <div
                      className={`label-large ${
                        whiteTextColour
                          ? 'text-brand-white'
                          : 'text-brand-dark-grey'
                      }`}
                    >
                      {colourName}
                    </div>
                    <div>
                      {isHover && index === hoveredIndex ? (
                        <Action
                          hover
                          whiteTextColour={whiteTextColour}
                        ></Action>
                      ) : (
                        <Action whiteTextColour={whiteTextColour}></Action>
                      )}
                    </div>
                  </div>
                </Link>
              );
            })}
          </div>
        )}
        {linkTitle && link && (
          <div className="body-1 flex cursor-pointer justify-end text-brand-dark-grey underline hover:opacity-75">
            <Link href={link} legacyBehavior>{linkTitle}</Link>
          </div>
        )}
      </div>
      <style jsx global>
        {`
          .mainText .wysiwyg p {
            padding-bottom: 40px;
            font-family: Roboto, Arial, sans-serif;
            font-weight: 300;
            font-size: 16px;
            line-height: 24px;
          }
        `}
      </style>
    </div>
  </>;
}

export default ArticleColourUsed
